import Image from './Image';

const HandImage = Image.extend`
  position: absolute;
`;

export default HandImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/ImageBlock/HandImage.jsx